<template>
	<TopTab />
	<div class="home-container">
		<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
			<van-swipe-item v-for="item in bannerList" :key="item.id">
				<div class="banner" :style="{ backgroundImage: `url(${item.carouselImg})` }"></div>
			</van-swipe-item>
		</van-swipe>
		<!-- 
		<div class="tab">
			<b>WORKS 作品推荐</b>
			<span>更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="goods">
			<ul class="nav">
				<li :class="{ active: active == 1 }" @click="active = 1">热门推荐</li>
				<li :class="{ active: active == 2 }" @click="active = 2">新品推荐</li>
				<li :class="{ active: active == 3 }" @click="active = 3">活动专区</li>
			</ul>
			<div class="goods_list">
				<ul>
					<li v-for="item in goodsList">
						<img :src="item.mainPicUrl" alt="">
						<p>{{ item.productName }}</p>
						<div class="icons">
							<img src="@/assets/imgs/icon4.png" alt="" v-if="item.assetId" @click="router.push({ path: '/assets-detail', query: { id: item.assetId } })">
							<img src="@/assets/imgs/icon3.png" alt="">
						</div>
					</li>
				</ul>
			</div>
		</div> -->
		<div class="tab">
			<b>ART 以艺术为核，以潮流为翼</b>
			<!-- <span>更多<van-icon name="arrow-double-right" /></span> -->
		</div>

		<div class="swiper_container">
			<swiper :loop="true" :slidesPerView="3" :spaceBetween="10" :modules="modules" class="mySwiper" :autoplay="{
				delay: 2500,
			}" :show-indicators="false">
				<swiper-slide v-for="item in swiperList">
					<div class="swiper_item" @click.stop="router.push({ path: '/art-detail', query: { id: item.id } })">
						<img :src="item.mainPicUrl" />
						<p>{{ item.opusName }}</p>
					</div>
				</swiper-slide>
			</swiper>
		</div>

		<div class="sep_line"></div>

		<div class="adbanner">
			<div>
				<img src="@/assets/imgs/bg15.jpg">
				<img src="@/assets/imgs/bg13.jpg">
			</div>
			<div>
				<img src="@/assets/imgs/bg14.jpg">
			</div>
		</div>

		<div class="sep_line"></div>

		<div class="tab">
			<b>INFO 艺术动态·前沿资讯</b>
			<span>更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="news">
			<NewsItem v-for="item in newsList" :data="item" />
		</div>

		<div class="tab">
			<b>ARTIST 艺术家</b>
			<span>更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="artist">
			<ul>
				<li v-for="item in artistList" @click="router.push({ path: '/artist-detail', query: { id: item.id } })">
					<div class="avatar" :style="`background-image: url(${item.avatar})`"></div>
					<p>{{ item.artistName }}</p>
					<p>{{ item.firstTitle }}</p>
				</li>
			</ul>
		</div>

		<div class="sep_line"></div>

		<div class="tab">
			<b>BRAND 品牌优势</b>
		</div>

		<div class="brand">
			<img src="@/assets/imgs/bg18.jpg" />
			<img src="@/assets/imgs/bg16.jpg" />
			<img src="@/assets/imgs/bg17.jpg" />
		</div>
		
		<div class="contact">
			<h5>联系我们</h5>
			<p>{{ websitConfig.websiteNames }}</p>
			<p><b>电话</b> <br /> {{ websitConfig.companyPhone }}</p>
			<p><b>邮箱</b> <br /> {{ websitConfig.email }}</p>
			<p><b>地址</b> <br /> {{ websitConfig.companyAddress }}</p>
		</div>
	</div>

	<FooterBar />

	<div class="help-btn">
		<div @click.stop="showConsult=true"><van-icon :name="require('@/assets/imgs/icon47.png')" size="22rem"></van-icon></div>
		<div @click.stop="router.push('/help-center')"><van-icon :name="require('@/assets/imgs/icon48.png')" size="28rem"></van-icon></div>
	</div>

	<div class="consult_wrapper" v-if="showConsult">
		<div class="consult">
			<span @click.stop="showConsult=false"></span>
		</div>
	</div>
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { onMounted, computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import * as api from '@/request/front'
import { richTextToPlainText } from '@/utils/util.js'
import FooterBar from '@/views/front/components/FooterBar.vue'
import { useStore } from 'vuex'
import NewsItem from '@/views/front/components/NewsItem.vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const modules = [Autoplay, Pagination, Navigation]
// const modules = []
const router = useRouter()
const store = useStore()
const bannerList = ref([])
const goodsList = ref([])
const newsList = ref([])
const artistList = ref([])
const websitConfig = computed(() => store.state.front.websitConfig)
const swiperList = ref(new Array(6).fill({}))
onMounted(() => {
	api.getBannerList(263).then(res => {
		bannerList.value = res.data.rows
	})
	fetchGoodsList(1)
	fetchNewsList()
	fetchArtistList()
	api.getWorksList(4).then(res => {
		swiperList.value = res.data.rows
	})
})

const active = ref(1)
watch(active, value => {
	fetchGoodsList(value)
})

function fetchGoodsList(type) {
	api.getWorksList(type).then(res => {
		goodsList.value = res.data.rows
	})
}

function fetchNewsList() {
	api.getNewsList(5, 2).then(res => {
		newsList.value = res.data.rows
	})
}

function fetchArtistList() {
	api.getArtistList(1, 4).then(res => {
		artistList.value = res.data.rows
	})
}

const showConsult = ref(false)

</script>

<style scoped lang="scss">
.home-container {
	padding-bottom: 50rem;

	.tab {
		display: flex;
		justify-content: space-between;
		padding: 20rem 15rem;

		span {
			font-size: 14rem;
			color: #8A8A8A;
		}
	}

	.swiper_container {
		height: 130rem;
		padding: 10rem 0;

		.mySwiper {
			height: 100%;

			.swiper-slide {
				transform: scale(0.8);
				transition: transform 0.3s ease-in-out;
			}

			.swiper-slide-next {
				transform: scale(1.2);

				.swiper_item {
					p {
						bottom: 10rem;
					}
				}
			}

			.swiper_item {
				height: 100%;
				position: relative;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				p {
					width: 100%;
					height: 24rem;
					line-height: 24rem;
					font-size: 14rem;
					color: #fff;
					background-color: rgba(0, 0, 0, 0.5);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					position: absolute;
					bottom: 0;
					left: 0;
				}
			}
		}
	}

	.adbanner {
		padding: 15rem;

		div {
			height: 146rem;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		div:nth-child(1) {
			display: flex;
			justify-content: space-between;
			height: 126rem;
			margin-bottom: 15rem;

			img {
				width: 48%;
				object-fit: cover;
			}
		}
	}

	.goods {
		padding: 0 15rem;

		.nav {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 40rem;
			border-bottom: 1px solid #F0F0F0;

			li {
				width: 60rem;
				height: 40rem;
				line-height: 40rem;
				margin: 0 10rem;
				font-size: 12rem;
				text-align: center;
				color: #9D9D9D;
			}

			.active {
				color: #000;
				font-weight: bolder;
				border-bottom: 2px solid #000;
			}
		}

		.goods_list {
			overflow-x: scroll;
			padding: 20rem 0;

			ul {
				display: flex;

				li {
					width: 190rem;
					flex-shrink: 0;
					margin-right: 18rem;
					position: relative;

					img {
						width: 100%;
						height: 152rem;
						object-fit: cover;
					}

					p {
						width: 100%;
						margin-top: 10rem;
						text-align: center;
						font-size: 14rem;
						color: #000;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}

					.icons {
						position: absolute;
						right: 5rem;
						top: 5rem;

						img {
							width: 15rem;
							height: auto;
							margin: 0 5rem;
						}
					}
				}
			}
		}

		.goods_list::-webkit-scrollbar {
			display: none;
		}

	}

	.artist {
		padding: 15rem;

		ul {
			display: flex;
			justify-content: space-between;

			li {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				.avatar {
					width: 88rem;
					height: 88rem;
					border-radius: 50%;
					background-size: cover;
					background-position: center;
				}

				p {
					margin-top: 10rem;
					font-size: 14rem;
					color: #000;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				p:nth-child(3) {
					font-size: 12rem;
					color: #999;
				}
			}
		}
	}

	.brand {
		padding: 0 15rem;

		img {
			width: 100%;
			margin: 10rem 0;
		}
	}

	.contact {
		margin-top: 100rem;

		h5 {
			text-align: center;
			margin-top: 10rem;
			font-size: 16rem;
		}

		p {
			text-align: center;
			line-height: 24rem;
			margin-top: 15rem;
		}
	}


}

.my-swipe {
	width: 100%;
	height: 160rem;

	.banner {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
	}
}

.help-btn {
	position: fixed;
	width: 50rem;
	left: 370rem;
	bottom: 20rem;

	>div {
		width: 50rem;
		height: 50rem;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.4);
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 5rem 0;
	}
}
.consult_wrapper{
	position: fixed;
	width: 100vw; height: 100vh; display: flex;
	align-items: center;
	justify-content: center;
	left: 0;
	top: 0;
	z-index: 100;
	background-color: rgba(0, 0, 0, 0.4);
}
.consult{
	width: 320rem; height: 410rem; position: relative;
	background: url('@/assets/imgs/bg19.png');
	background-size: cover;
	span{
		width: 50rem; height: 50rem; display: inline-block; position: absolute; right: 0;
	}
}
</style>
